import { render, staticRenderFns } from "./district-reports.vue?vue&type=template&id=6a2bdb43&lang=pug&"
import script from "./district-reports.vue?vue&type=script&lang=js&"
export * from "./district-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports